module.exports = __webpack_public_path__ + "static/img/Screenshot_2019-01-10 Y S-min.ab7eae9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screenshot_2019-01-10 Y S-min.jpg
// module id = 1bEW
// module chunks = 1